import { render } from "./AppTakePhotoOptions.vue?vue&type=template&id=339dedda&scoped=true&ts=true"
import script from "./AppTakePhotoOptions.vue?vue&type=script&lang=ts"
export * from "./AppTakePhotoOptions.vue?vue&type=script&lang=ts"

import "./AppTakePhotoOptions.vue?vue&type=style&index=0&id=339dedda&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339dedda"]])

export default __exports__